import React from 'react'
import Input from './Input'

const getFieldValue = ({ files }) => [...files]

const FileInput = (props) => <Input {...props} type='file' getFieldValue={getFieldValue} />

export default FileInput
